<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Current Software Provider</h1>
    <p>We'd like to make the switch to Qtac as painless as possible for you.</p>
    <p>To identify the easiest way to move your payroll to Qtac, please provide the name of the software that your payroll is currently processed?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
        <label >Previous Software Provider</label>
        <AutoSuggest
            v-model="formData.currentPayrollSoftwareProvider"
            :suggestions="softwareProviders"
            name="currentPayrollSoftwareProvider"
            regexPattern="[A-Za-z0-9' ]*" />

            <label class="custom-check">
             <input type="checkbox" v-model="formData.currentPayrollSoftwareProviderUnknown">I'm not sure who my current payroll software provider is
            <span class="checkmark"></span>
        </label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch, onMounted } from 'vue'
import AutoSuggest from '@/components/controls/AutoSuggest.vue'

import softwareProviders from '@/helpers/arrays/supportedPreviousPayrollProviders';

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  if (!props.formData.currentPayrollSoftwareProviderUnknown && !props.formData.currentPayrollSoftwareProvider) {
    error.value = 'Please enter your current payroll software provider or select "I\'m not sure".';
    return false;
  }
  error.value = null;

  return true;
}



const executeStep = async () => {
  return true;
}


watch(
  () => props.formData.currentPayrollSoftwareProviderUnknown,
  (newValue) => {
    if (newValue) {
      props.formData.currentPayrollSoftwareProvider = '';
      document.getElementById('currentPayrollSoftwareProvider').disabled = true;
    } else {
      document.getElementById('currentPayrollSoftwareProvider').disabled = false;
    }
  }
);



onMounted(() => {
  if (props.formData.currentPayrollSoftwareProviderUnknown) {
    document.getElementById('currentPayrollSoftwareProvider').disabled = true;
  }


});

defineExpose({ validateStep, executeStep });

</script>